// Copyright (c) Docugami, Inc. All rights reserved.

import { StringBuilder } from "utils/StringBuilder";

export class DgParagraphMetadata {
    public ParagraphGuid: string;
    public KnownChunkType: DgKnownChunkType;
    public Ids: string;
    constructor(paragraphGuid: string, knownChunkType: DgKnownChunkType, ids: string)
    {
        this.ParagraphGuid = paragraphGuid;
        this.KnownChunkType = knownChunkType;
        this.Ids = ids;
    }
}

export enum DgKnownChunkType {
    Matched = "Matched",
    Inserted = "Inserted",
    Replaced = "Replaced"
}

export class DgKnownChunk {
    public KnownChunkType: DgKnownChunkType;
    public Id: string; // in the case of matched or replaced content, this is the span Id.  For inserted content, this is the chunk suggestion id.
    public IsAncestor: boolean; // added to known chunks because it is an ancestor of a known chunk
    constructor(knownChunkType: DgKnownChunkType, id: string, isAncestor: boolean)
    {
        this.KnownChunkType = knownChunkType;
        this.Id = id;
        this.IsAncestor = isAncestor;
    }

    public static dump(tag: string, knownChunks: DgKnownChunk[]): string
    {
        const sb = new StringBuilder();
        for (let cnt = 0; cnt < knownChunks.length; ++cnt)
        {
            sb.appendLine(`${tag} ${knownChunks[cnt].KnownChunkType} ${knownChunks[cnt].Id}`);
        }
        return sb.toString();
    }
}
